
import { useScrollAnimation, getAnimationClass } from '../../../hooks/useScrollAnimation';

function AnimatedSection({ children, animation = 'slide-up' as 'fade-in' | 'slide-up' | 'slide-left' | 'slide-right' | 'scale-in', delay = 0, className = '' }: { children: React.ReactNode; animation?: 'fade-in' | 'slide-up' | 'slide-left' | 'slide-right' | 'scale-in'; delay?: number; className?: string }) {
  const { ref, isVisible } = useScrollAnimation();
  return (
    <div ref={ref} className={`${getAnimationClass(isVisible, animation, delay)} ${className}`}>
      {children}
    </div>
  );
}

export default function OpticaModule() {
  const features = [
    { icon: 'ri-glasses-line', title: 'Gestión de monturas y lentes', desc: 'Catálogo completo con fotos, precios, stock y proveedores de cada producto óptico.' },
    { icon: 'ri-archive-line', title: 'Control de inventario en tiempo real', desc: 'Alertas de stock bajo, movimientos automáticos y reportes de rotación de productos.' },
    { icon: 'ri-price-tag-3-line', title: 'Promociones y descuentos', desc: 'Crea campañas de descuento, combos de lentes + monturas y ofertas estacionales.' },
    { icon: 'ri-truck-line', title: 'Integración con proveedores', desc: 'Pedidos automáticos a laboratorios ópticos y seguimiento de entregas en tiempo real.' },
    { icon: 'ri-bar-chart-box-line', title: 'Analíticas de ventas', desc: 'Reportes de productos más vendidos, márgenes de ganancia y tendencias de compra.' },
    { icon: 'ri-qr-code-line', title: 'Código de barras y etiquetas', desc: 'Genera e imprime etiquetas con código de barras para cada producto de tu óptica.' },
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-emerald-50/50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center mb-20">
          <AnimatedSection animation="slide-left">
            <div className="space-y-6">
              <div className="inline-flex items-center space-x-2 px-3 py-1 bg-emerald-100 rounded-full">
                <span className="w-2 h-2 bg-emerald-500 rounded-full animate-pulse"></span>
                <span className="text-[11px] font-bold text-emerald-700 uppercase tracking-wider">Nuevo Módulo</span>
              </div>
              <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 leading-tight">
                Módulo de Óptica<br /><span className="font-display italic text-emerald-600">Integrado</span>
              </h2>
              <p className="text-sm text-gray-600 leading-relaxed max-w-lg">
                Gestiona tu óptica y tu consulta oftalmológica desde una sola plataforma. Control total de inventario, ventas, monturas, lentes y proveedores integrado directamente con los historiales clínicos de tus pacientes.
              </p>
              <div className="pt-2">
                <a href="https://anamnesysoft.com/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center space-x-2 px-7 py-3 bg-emerald-500 text-white text-sm font-semibold rounded-lg hover:bg-emerald-600 transition-all whitespace-nowrap cursor-pointer">
                  <span>Registrarse / Ingresar</span>
                  <i className="ri-arrow-right-line text-base"></i>
                </a>
              </div>
            </div>
          </AnimatedSection>

          <AnimatedSection animation="slide-right">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl border border-gray-100">
              <div className="w-full h-80 lg:h-96">
                <img
                  src="https://readdy.ai/api/search-image?query=modern%20optical%20store%20management%20software%20dashboard%20on%20computer%20screen%20showing%20eyeglasses%20inventory%20frames%20catalog%20sales%20analytics%20in%20professional%20optometry%20clinic%20with%20emerald%20green%20accent%20colors%20clean%20minimal%20UI%20design&width=700&height=500&seq=optica-module-showcase-1&orientation=landscape"
                  alt="Módulo de Óptica Anamnesy Soft"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute top-4 left-4 bg-emerald-500 text-white text-[10px] font-bold px-3 py-1.5 rounded-full uppercase tracking-wider shadow-lg">
                Incluido en Plan Profesional
              </div>
            </div>
          </AnimatedSection>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <AnimatedSection key={index} animation="scale-in" delay={index * 100}>
              <div className="group p-6 rounded-xl border border-gray-100 hover:border-emerald-200 hover:shadow-lg transition-all cursor-pointer bg-white h-full">
                <div className="w-12 h-12 bg-emerald-50 rounded-xl flex items-center justify-center mb-5 group-hover:bg-emerald-100 group-hover:scale-110 transition-all">
                  <i className={`${feature.icon} text-emerald-600 text-xl`}></i>
                </div>
                <h3 className="text-base font-bold text-gray-900 mb-2">{feature.title}</h3>
                <p className="text-sm text-gray-500 leading-relaxed">{feature.desc}</p>
              </div>
            </AnimatedSection>
          ))}
        </div>
      </div>
    </section>
  );
}
